<div class="header">
  <div class="create-app-button">
    <a class="button button-green" (click)="createApp()">
      <div *ngIf="!this.globals.isCreateApplication" >Create Application</div>
      <div *ngIf="this.globals.isCreateApplication">Application List</div>
    </a>
  </div>
  <div *ngIf="!this.globals.isCreateApplication" class="app-list-button">
    <a class="button button-green" (click)="toggleApplications()">
      <div *ngIf= "!this.globals.allApplications">All Application</div>
      <div *ngIf= "this.globals.allApplications">My Applications</div>
    </a>
  </div>
  <div class="logout-button">
    <a class="button button-red" (click)="logout()">
      Log Out
    </a>
  </div>
</div>
